import {
    IAppInfo,
    IAppSession,
    IMatomoCommonDimensionIds,
    IMatomoConfiguration,
    IMatomoCustomDimensionCallback,
    IMatomoDimension,
    IUser,
    MatomoStatsUrl
} from "@logex/framework/lg-application";

const LGX_ACM_ID = 51;
// setup of custom dimensions is same for all environments (at least for now)
const ORGANIZATION_CODE_DIMENSION = 1;
const ORGANIZATION_NAME_DIMENSION = 2;
const USER_TYPE_DIMENSION = 3;
const INSTANCE_VERSION_YEAR = 4;

export class MatomoConfiguration implements IMatomoConfiguration {
    siteId: number;
    statUrl: string;
    commonDimensionIds: IMatomoCommonDimensionIds;
    customDimensions: IMatomoDimension[] | IMatomoCustomDimensionCallback;
    registry?: string;

    autoTrack = true;
    autoInit: false;

    private readonly _doTrace: boolean;
    constructor(_appInfo: IAppInfo, _appSession: IAppSession, _user: IUser) {
        this.siteId = LGX_ACM_ID;
        this.statUrl = MatomoStatsUrl.Logex;
        this.commonDimensionIds = {};

        if (_appSession != null) {
            this.customDimensions = [
                {
                    name: "Organization code",
                    id: ORGANIZATION_CODE_DIMENSION,
                    value: _appSession.client.id
                },
                {
                    name: "Organization name",
                    id: ORGANIZATION_NAME_DIMENSION,
                    value: _appSession.client.name
                },
                {
                    name: "User type",
                    id: USER_TYPE_DIMENSION,
                    value: _user.hasPermission("internal") ? "internal" : "external"
                },
                {
                    name: "Intance version",
                    id: INSTANCE_VERSION_YEAR,
                    value: _appInfo.toolInstanceName.substring(
                        _appInfo.toolInstanceName.indexOf("_") + 1
                    )
                }
            ];
        }

        this._doTrace = !!_appInfo.isProduction();
    }

    doNotDoMatTracking(): boolean {
        return !this._doTrace;
    }
}
